import {
  all,
  fork,
  put,
  takeEvery,
  takeLatest,
  // select,
  // takeLatest
} from "redux-saga/effects";
import {
  REQUEST_SELECTION_DATA_SUCCESS,
  SUBMIT_SUGGEST_PRODUCT,
  getSelectionData,
  setSelections,
  suggestProduct,
  REQUEST_SEND_BOQ_FAILURE,
  REQUEST_SEND_BOQ_SUCCESS,
  ACTION_ADD_TO_CART,
} from "./index";
import { toast } from "react-toastify";

function* loadRouteData() {
  // const {home} = yield select();
  // const {
  //     productFilter
  // } = home;
  yield put(getSelectionData());
}

function* handleListenActions() {
  yield takeEvery(REQUEST_SELECTION_DATA_SUCCESS, function* (action) {
    const vavTypeList = action.payload.data.vavTypeList;
    let vavTypeListFormated = {};
    let resultObject = {};
    vavTypeList.forEach((item) => {
      const { vavFunction, bodyType, hasAcctuator } = item;
      if (!resultObject[vavFunction]) {
        resultObject[vavFunction] = {};
      }

      resultObject[vavFunction][bodyType] = {
        ...resultObject[vavFunction][bodyType],
        bodyType: item.bodyType,
        bodyImage: item.bodyImage
          ? item.bodyImage
          : resultObject[vavFunction][bodyType].bodyImage,
        bodyModel: item.bodyModel,
      };

      if (!resultObject[vavFunction][bodyType]["hasAcctuator"]) {
        resultObject[vavFunction][bodyType]["hasAcctuator"] = {};
      }

      resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator] = {
        ...resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator],
        acctuator: item.acctuator,
        acctuatorPrice: item.acctuatorPrice
          ? item.acctuatorPrice
          : resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator]
              ?.acctuatorPrice,
        acctuatorImage: item.acctuatorImage
          ? item.acctuatorImage
          : resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator]
              ?.acctuatorImage,
        modelNo: hasAcctuator === "no" ? item.modelNo : "",
        note: hasAcctuator === "no" ? item.note : "",
      };

      if (
        !resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator][
          "controllers"
        ]
      ) {
        resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator][
          "controllers"
        ] = [];
      }
      if (hasAcctuator === "yes") {
        resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator][
          "controllers"
        ] = [
          ...resultObject[vavFunction][bodyType]["hasAcctuator"][hasAcctuator][
            "controllers"
          ],
          {
            controllerCode: item.controllerCode,
            controller: item.controller,
            controllerPrice: item.controllerPrice,
            controllerImage: item.controllerImage,
            note: item.note,
            modelNo: item.modelNo,
          },
        ];
      }
    });
    vavTypeListFormated = resultObject;
    yield put(setSelections(vavTypeListFormated));
  });

  yield takeEvery(SUBMIT_SUGGEST_PRODUCT, function* (action) {
    // call api
    yield put(
      suggestProduct({
        boxType: action.payload.boxType,
        airflowUnit: action.payload.airflowUnit,
        airflowValue: action.payload.airflow,
        noiseNc: action.payload.noisecriterionnclevel,
        bodyType: action.payload.bodyType,
      })
    );
  });
}

function* handleSendBOQFailure() {
  // eslint-disable-next-line require-yield
  yield takeLatest(REQUEST_SEND_BOQ_FAILURE, function* () {
    toast.error('Request send boq mail failure');
  });
}

function* handleSendBOQSuccess() {
  // eslint-disable-next-line require-yield
  yield takeLatest(REQUEST_SEND_BOQ_SUCCESS, function* () {
    toast.success('Request send boq mail successfully');
  });
}

function* handleAddToCartSuccess() {
  // eslint-disable-next-line require-yield
  yield takeLatest(ACTION_ADD_TO_CART, function* () {
    toast.success("Product added to cart successfully");
  });
}

export function* loadOrderPage() {
  yield all([
    fork(loadRouteData),
    fork(handleListenActions),
    fork(handleAddToCartSuccess),
    fork(handleSendBOQSuccess),
    fork(handleSendBOQFailure),
  ]);
}
